module.exports = __webpack_public_path__ + "img/logo_short.91a97078.png";